<template>
  <div class="container">
    <div class="flex-container flexbox-container--drilldown-categories">
      <div class="flexbox-container--drilldown-categories">
        <div
          class="widget widget-filters widget-filters--offcanvas---catalog-mobile"
          data-collapse
          data-collapse-opened-class="filter--opened" v-if="this.groups.length > 0" >
          <!-- <div class="widget__header-catalog widget-filters__header">
            <h4>Categories</h4>
          </div> -->
          <div class="widget-filters__item">
            <div class="filter filter--opened" data-collapse-item>
              <button type="button" class="filter__title" data-collapse-trigger>
                  <div class="drilldown-header"><h4 class="drilldown-header">{{categoryHeaderText}}</h4></div>
              </button>
              <div class="filter__body" data-collapse-content>
                <div class="filter__container">
                  <div class="filter-list">
                    <div class="filter-list__list">
                      <label class="filter-list__item" v-for="group in groups" :key="group.group">
                        <span class="input-check filter-list__input">
                          <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" :value="group.group" v-model="selgroups" @change="selectCategory($event)" />
                            <span class="input-check__box"></span>
                            <span class="input-check__icon"
                              ><svg width="9px" height="7px">
                                <path
                                  d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z"
                                />
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span class="filter-list__title">
                          {{ group.description }} [{{group.group}}]
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flexbox-container--drilldown-categories" v-if="this.categories.length > 0">
        <div class="widget widget-filters widget-filters--offcanvas---catalog-mobile"
          data-collapse
          data-collapse-opened-class="filter--opened" >
          <!-- <div class="widget__header-catalog widget-filters__header">
            <h4>Groups</h4>
          </div> -->
          <div class="widget-filters__item">
            <div class="filter filter--opened" data-collapse-item>
              <button type="button" class="filter__title" data-collapse-trigger>
                  <div class="drilldown-header"><h4 class="drilldown-header">{{subcategoryHeaderText}}</h4></div>
              </button>
              <div class="filter__body" data-collapse-content>
                <div class="filter__container">
                  <div class="filter-list">
                    <div class="filter-list__list">
                      <label class="filter-list__item">
                        <span class="input-check filter-list__input">
                          <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" @change="checkGroupAll($event)"/>
                            <span class="input-check__box"></span>
                            <span class="input-check__icon">
                              <svg width="9px" height="7px">
                                <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z"/>
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span class="filter-list__title">
                          All
                        </span>
                      </label>
                      <label class="filter-list__item" v-for="category in categories" :key="category.categorycode">
                        <span class="input-check filter-list__input">
                          <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" v-model="selcategories" :value="category.categorycode" @change="selectGroup($event, category)" />
                            <span class="input-check__box"></span>
                            <span class="input-check__icon">
                              <svg width="9px" height="7px">
                                <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z"/>
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span class="filter-list__title">
                          {{ category.description }} [{{category.categorycode}}]
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flexbox-container--drilldown-categories" v-if="this.questions.length > 0">
        <div
          class="widget widget-filters widget-filters--offcanvas---catalog-mobile"
          data-collapse
          data-collapse-opened-class="filter--opened"
        >
          <div class="widget__header-catalog widget-filters__header">
            <h4>Counterman Questions</h4>
          </div>
          <div class="widget-filters__item">
            <div class="filter filter--opened" data-collapse-item>
              <button type="button" class="filter__title" data-collapse-trigger>
                Expand/Collapse
                <span class="filter__arrow"
                  ><svg width="12px" height="7px">
                    <path
                      d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z"
                    /></svg
                ></span>
              </button>
              <div class="filter__body" data-collapse-content>
                <div class="filter__container">
                  <div class="filter-list">
                    <div class="filter-list__list">
                      <label class="filter-list__item" v-for="question in questions" :key="question.QCQUID">
                        <span class="input-check filter-list__input">
                          <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" v-model="selquestions" :value="question.QCQUID" />
                            <span class="input-check__box"></span>
                            <span class="input-check__icon"
                              ><svg width="9px" height="7px">
                                <path
                                  d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z"
                                />
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span class="filter-list__title"> {{ question.QCQUTX }} </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-container--drilldown-3">
        <div class="flex-container--drilldown-select-vehicle-inputs">
          <!-- <a href="/search-results" class="btn btn-lg btn-checkout">GO</a> -->
          <button type="button" class="btn btn-lg btn-checkout" @click="searchParts()">Go</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axiosvl from "../../../axios/axios-vl.js";

export default {
  data() {
    return {
      categories: [],
      groups: [],
      questions: [],
      types: [],
      selcategories: [],
      selgroups: [],
      selquestions: [],

      checkedCat: [],
      checkedGroup: [],
      storeCatalog: '',
    };
  },
  computed: {
    ...mapGetters("vehicle", [
        'selectedvehicle'
    ]),

    ...mapGetters(['storeCatalog']),

    categoryHeaderText() {
        if(this.storeCatalog == 'PARTSLINK'){
            return "Groups";
        }else{
          return "Categories";
        }
    },

    subcategoryHeaderText() {
        if(this.storeCatalog == 'PARTSLINK'){
            return "Sub-Groups";
        }else{
          return "Groups";
        }
    }},
  watch: {
    selectedvehicle() {
      this.selcategories = [], this.selgroups = [], this.selquestions = [];
      this.getCategoryCriteria();
    }
  },
  methods: {
    getWhiGroups() {
      const expand_sel_uri = this.$store.getters['api/expand_sel_uri'];
      const catpn = this.$store.getters['storeConfigID'];
      axiosvl.post(expand_sel_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {
                          "value": this.$store.getters.customer
                      },
                      "CATPN": {
                          "value": catpn
                      }
                  }           
              }
          }
      )
      .then((response) => {
          const results = [];
          const fields = response.data.webroutine.fields
          if (fields.RESULTCOD.value === 'OK') {
              for (const key in response.data.webroutine.lists.GROUPSD.entries) {
                  const obj = response.data.webroutine.lists.GROUPSD.entries[key];
                  results.push({
                      group: obj.QGROUP,
                      description: obj.QGRDSC,
                      QGRDSCR: obj.QGRDSCR,
                  });
              }
              this.groups = results;
          }
      })
      .catch((error) => {
          console.log("error - " + error);
      });
    },
    getWhiCategories(categories) {
        const paramcats = [];
        categories.forEach(cat => {
          paramcats.push([cat]);
        });

      // const vehicle_categories_uri = this.$store.getters['api/vehicle_categories_uri'];
      const vehicle_categoriesm_uri = this.$store.getters['api/vehicle_categoriesM_uri'];
      const catpn = this.$store.getters['storeConfigID'];
      // const url = "/D15PGMLIB/lansaweb?w=whi&r=categories&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
      axiosvl.post(vehicle_categoriesm_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {
                          "value": this.$store.getters.customer
                      },
                      "CATPN": {
                          "value": catpn
                      },
                      // "QGROUP": {
                      //   "value": group
                      // }
                  },
                  lists: {
                    "GROUPSI": {
                        "header": [
                            {"name": "QGROUP"}
                        ],
                        "entries": paramcats
                    }
                }   
              }
          }
      )
      .then((response) => {
          const results = [];
          const fields = response.data.webroutine.fields
          if (fields.RESULTCOD.value === 'OK') {
              for (const key in response.data.webroutine.lists.CATSD.entries) {
                  const obj = response.data.webroutine.lists.CATSD.entries[key];
                  results.push({
                      categorycode: obj.QGRDSC,
                      description: obj.QCAT,
                      group: obj.QGROUP,
                      type: obj.QTYPE,
                      QCAENR: obj.QCAENR,
                      QGRDSCR: obj.QGRDSCR,
                  });
              }
              this.categories = results;
          }
      })
      .catch((error) => {
          console.log("error - " + error);
      });
    },
    getWhiCountermanQuestions() {

      const paramstypesi = [];

      this.checkedGroup.forEach(checked => {
          paramstypesi.push([checked.categorycode, checked.group]);
      });
      
      // const counterman_uri = this.$store.getters['api/counterman_uri'];
      const countermanM_uri = this.$store.getters['api/countermanM_uri'];
      const catpn = this.$store.getters['storeConfigID'];
      // console.log(countermanM_uri);
      // const url = "/D15PGMLIB/lansaweb?w=whi&r=countermanQuestions&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
      axiosvl.post(countermanM_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": { "value": this.$store.getters.customer },
                      "CATPN": { "value": catpn },
                      "QYEAR": { "value": this.$store.getters['vehicle/selectedyear'] },
                      "QMAKE": { "value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                      "QMODEL": { "value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                      "QCARCD": { "value": this.$store.getters['vehicle/selectedengine'].selectedengine },
                      // "QGROUP": { "value": this.selgroups[0] },
                      // "QTYPE": { "value": this.selcategories[0] }
                  },
                  "lists": {
                      "TYPESI": {
                          "header": [
                              {"name": "QTYPE"},
                              {"name": "QGROUP"}
                          ],
                          "entries": paramstypesi
                      }
                  }
              }
          }
      )
      .then((response) => {
          const results = [];
          const fields = response.data.webroutine.fields
          if (fields.RESULTCOD.value === 'OK') {
              for (const key in response.data.webroutine.lists.CQUSD.entries) {
                  const obj = response.data.webroutine.lists.CQUSD.entries[key];
                  results.push({
                      QCQUIX: obj.QCQUIX,
                      QCQUID: obj.QCQUID,
                      QCQUTX: obj.QCQUTX,
                      QCQUTY: obj.QCQUTY,
                      QCQUAN: obj.QCQUAN,
                      QCQUGR: obj.QCQUGR,
                      QCQUUK: obj.QCQUUK,
                      QCQUAT: obj.QCQUAT,
                      QCQUAR: obj.QCQUAR,
                      QCQUAI: obj.QCQUAI,
                  });
              }
              this.questions = results;
          }
      })
      .catch((error) => {
          console.log("error - " + error);
      });
    },
    getPartslinkGroups() {
      
      const vehicle_group_uri = this.$store.getters['api/vehicle_group_uri'];
      const catpn = this.$store.getters['storeConfigID'];
      // const url = "/D15PGMLIB/lansaweb?w=whi&r=groups&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
      axiosvl.post(vehicle_group_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {
                          "value": this.$store.getters.customer
                      },
                      "CATPN": {
                          "value": catpn
                      }
                  }           
              }
          }
      )
      .then((response) => {
          const results = [];
          const fields = response.data.webroutine.fields
          if (fields.RESULTCOD.value === 'OK') {
              for (const key in response.data.webroutine.lists.GROUPSD.entries) {
                  const obj = response.data.webroutine.lists.GROUPSD.entries[key];
                  results.push({
                      group: obj.QGROUP,
                      description: obj.QGRDSC,
                      QGRDSCR: obj.QGRDSCR,
                  });
              }
              this.groups = results;
          }
      })
      .catch((error) => {
          console.log("error - " + error);
      });
    },
    getPartslinkTypes(categories) {
      const paramcats = [];
      categories.forEach(cat => {
        paramcats.push([cat]);
      });
      // const vehicle_group_uri = this.$store.getters['api/vehicle_group_uri'];
      const vehicle_group_uri = this.$store.getters['api/vehicle_typeM_uri'];
      const catpn = this.$store.getters['storeConfigID'];
      // const url = "/D15PGMLIB/lansaweb?w=whi&r=groups&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
      axiosvl.post(vehicle_group_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {
                          "value": this.$store.getters.customer
                      },
                      "CATPN": {
                          "value": catpn
                      },
                      "QYEAR": {
                          "value": this.$store.getters['vehicle/selectedyear']
                      },
                      "QMKDSC": {
                          "value": this.$store.getters['vehicle/selectedmake'].desc
                      },
                      "QMODSC": {
                          "value": this.$store.getters['vehicle/selectedmodel'].desc
                      },
                      // "QGROUP": {
                      //     "value": "1000"
                      // },
                  },
                  "lists": {
                     "GROUPSI": {
                        "header": [
                            {"name": "QGROUP"}
                        ],
                        "entries": paramcats
                    }
                  }
              }
          }
      )
      .then((response) => {
          const results = [];
          // const fields = response.data.webroutine.fields
          this.categories = [];
          // if (fields.RESULTCOD.value === 'OK') {
              for (const key in response.data.webroutine.lists.CATSD.entries) {
                  const obj = response.data.webroutine.lists.CATSD.entries[key];
                  results.push({
                      categorycode: (this.storeCatalog.toUpperCase() == 'WHI') ? obj.QGRDSC : obj.QTYPE,
                      description: obj.QCAT,
                      group: obj.QGROUP,
                      type: obj.QTYPE,
                      QCAENR: obj.QCAENR,
                      QGRDSCR: obj.QGRDSCR,
                  });
              }
              this.categories = results;
              // console.log(this.categories);
          // }
      })
      .catch((error) => {
          console.log("error - " + error);
      });
    },
    getCategoryCriteria() {
      this.categories = [], this.groups = [], this.types = [];

      if (this.$store.getters['storeCatalog'] === 'WHI') {
        this.getWhiGroups();
      } else if (this.$store.getters['storeCatalog'] === 'PARTSLINK') {
        this.getPartslinkGroups();
      }
    },
    selectCategory(e) {
      this.selcategories = [];
      this.checkedGroup = [];
      const checkedVal = e.target.value;
      if (e.target.checked) {
        this.checkedCat.push(checkedVal);
      }else{
        const index = this.checkedCat.indexOf(checkedVal);
        if (index > -1) {
          this.checkedCat.splice(index, 1);
        }
      }

      
      if(this.storeCatalog.toUpperCase() == 'WHI'){
        this.getWhiCategories(this.checkedCat);
      }else{
        this.getPartslinkTypes(this.checkedCat);
      }

      // getWhiCategories(e.relatedTarget.value);
    },

    /**
     * on check/uncheck for ALL sub-groups or 2nd column
     * */
    checkGroupAll(e) {
      this.selcategories = [];
      this.checkedGroup = [];

      if (e.target.checked) {
        this.categories.forEach(c => {
          this.checkedGroup.push(c);
          this.selcategories.push(c.categorycode);
        });
      }else{
        this.selcategories = [];
        this.checkedGroup = [];
      }

      const isLoggedin = this.$store.getters['userIsAuthenticated'];
      // counterman questions is only for logged in users
      if(isLoggedin){
        if(this.storeCatalog.toUpperCase() == 'WHI'){
          this.getWhiCountermanQuestions();
        }
      }
    },

    /**
     * on check of each sub-groups or 2nd column
     * */
    selectGroup(e, groupCol) {
      // console.log(groupCol);
      this.selquestions = [];

      if (e.target.checked) {
        this.checkedGroup.push(groupCol);
      }else{

        this.checkedGroup = this.checkedGroup.filter(grp => {
          return grp.categorycode != groupCol.categorycode
        });
      }
      
      const isLoggedin = this.$store.getters['userIsAuthenticated'];
      // counterman questions is only for logged in users
      if(isLoggedin){
        if(this.storeCatalog.toUpperCase() == 'WHI'){
          this.getWhiCountermanQuestions();
        }
      }
      
    },

    searchParts() {
      const selectedquestions = [];
      const selectedgroups = [];
      const selectedcategories = [];
      let industry_sels = [];

      // build the params depends on the storecatalog
      // they have different format on params
      if (this.storeCatalog.toUpperCase() == 'WHI') {
        for (let x in this.selquestions) {
          selectedquestions.push(
            this.questions.find(q => {
              return q.QCQUID = this.selquestions[x];
            })
          );
        }

        for (let x in this.selcategories) {
          let category = this.categories.filter((cat) => {
            return cat.type === this.selcategories[x];
          });

          // console.log(category[0]);
          selectedcategories.push([category[0].type, category[0].group]);
          industry_sels.push(['', category[0].description]);
        }

      }else{
        
        // for (let x in this.selgroups) {
        //   selectedgroups.push([this.selgroups[x]]);
        // }
        
        for (let x in this.selcategories) {
          let category = this.categories.filter((cat) => {
            return cat.type === this.selcategories[x];
          });
          industry_sels.push(['', category[0].description]);
        }
        // console.table(industry_sels);

        // console.log(this.checkedGroup);
        this.checkedGroup.forEach(checked => {
          // console.log(checked);
          selectedcategories.push([checked.type, checked.group]);
        });
      }
      // console.log(selectedcategories);
      this.$store.dispatch('vehicle/setSelectedCategories', selectedcategories);
      this.$store.dispatch('vehicle/setSelectedGroups', selectedgroups);
      this.$store.dispatch('vehicle/setSelectedQuestions', selectedquestions);

      this.$store.dispatch('vehicle/setIndustry_sels', industry_sels);

      this.$router.push("/search-results");
    },
  },
  created() {
    this.selcategories = [], this.selgroups = [], this.selquestions = [];
    this.getCategoryCriteria();

    this.storeCatalog = this.$store.getters['storeCatalog'];
    
  }
}
</script>